import ComingSoonPage from "components/common/ComingSoonPage/ComingSoonPage";
import CreateFormTemplate from "components/DynamicForms/CreateFormTemplate/CreateFormTemplate";
import { USER_ROLE } from "Constants/constant";
import MyTaskPlanner from "../pages/ServiceProvider/MyTaskPlanner/MyTaskPlanner.container";
import ConfirmedPassword from "pages/Authentication/ForgetPassword/ConfirmedPasswoerd/ConfirmedPasswoerd";
import ForgetPassword from "pages/Authentication/ForgetPassword/ForgetPassword";
import SetPassword from "pages/Authentication/ForgetPassword/SetPassword/SetPassword";
import FamilySetPassword from "pages/Authentication/FamilySetPassword/FamilySetPassword";
import PayrollAuthCallback from "pages/Authentication/payroll/PayrollAuthCallback";
import SignIn from "pages/Authentication/SignIn/SignIn";
import SignUp from "pages/Authentication/SignUp/SignUp";
import SubmittedForms from "pages/EmployeePortal/Pages/SubmittedForms/index";
import ReleaseNotes from "pages/ReleaseNotes";
import ExportHistory from "pages/Reporting/ExportHistory/ExportHistory";
import ReportingModule from "pages/Reporting";
import BSPReports from "pages/Reporting/BSPReports/BSPReports";
import CaseNoteReportsContainer from "pages/Reporting/CasenoteReports";
import ComplaintsReports from "pages/Reporting/ComplaintsReports/ComplaintsReports";
import COSReportsContainer from "pages/Reporting/COSReports/COSReports.container";
import DetailedInvoicingReport from "pages/Reporting/DetailedInvoicingReports/DetailedInvoicingReports.container";
import FeedbackReports from "pages/Reporting/FeedbackReports/FeedbackReports.container";
import FundingReportsContainer from "pages/Reporting/FundingReports/FundingReports.container";
import IncidentReports from "pages/Reporting/IncidentReports/IncidentReports.container";
import IncidentManagementReports from "pages/Reporting/IncidentManagementReports";
import InvoicingReports from "pages/Reporting/InvoicingReports";
import KYPReportsContainer from "pages/Reporting/KYPReports/KYPReports.container";
import ParticipantExpiringDocReportsContainer from "pages/Reporting/ParticipantExpiringDocReports/ParticipantExpiringDocReports.container";
import ParticipantListReports from "pages/Reporting/ParticipantListReports/index";
import RiskAssessmentReports from "pages/Reporting/RiskAssessmentReports/RiskAssessmentReports.container";
import RocReports from "pages/Reporting/RocReports/index";
import ROCWeeklyReport from "pages/Reporting/ROCWeeklyReport/ROCWeeklyReport.container";
import SummaryInvoicingReport from "pages/Reporting/SummaryInvoicingReport/SummaryInvoiceReports.container";
import WorkerListReports from "pages/Reporting/WorkerListReports/index";
import RosteringDashboard from "pages/Rostering/Dashboard/Dashboard";
import ExportTimeSheet from "pages/Rostering/ExportTimeSheet/index";
import CreateRosterInvoicing from "pages/Rostering/Invoicing/CreateRosterInvoicing/CreateRosterInvoicing";
import RosterInvoicingDashboard from "pages/Rostering/Invoicing/Dashboard";
import RosterInvoicePreview from "pages/Rostering/Invoicing/InvoicePreview";
import RosterInvoicing from "pages/Rostering/Invoicing/RosterInvoices";
import Schedule from "pages/Rostering/Schedule/index";
import AskQuestion from "pages/ServiceProvider/AskQuestion/index";
import NotificationSettings from "pages/ServiceProvider/NotificationSettings";
import PayrollSetting from "pages/ServiceProvider/PayrollSetting";
import RolesAndPermissions from "pages/ServiceProvider/RolesPermissionsSettings/index";
import RegionSetting from "pages/ServiceProvider/SpSetting/RegionSetting";
import StaffCompliance from "pages/ServiceProvider/SpSetting/StaffCompliance/index";
import ParticipantComplianceEdit from "pages/ServiceProvider/SpSetting/ParticipantComplianceSettings/ParticipantCompliance.container";
import PricingTable from "pages/Stripe/Pricing/PricingTable";
import SubscriptionDetailsDashboard from "pages/Stripe/Subscription/Dashboard";
import { Navigate } from "react-router";
import {
  BLK_PORTAL_PREMISSION_KEYS_CHILDREN,
  PAYROLL_PLATFORMS,
  PERMISSION_KEYS,
  PERMISSION_KEYS_CHILDREN,
} from "store/constants";
import { ROSTERING_LEAVE_ACCESS_CHILDREN } from "helpers/RolesPermission";
import HumanBody from "../components/common/HumanBody/HumanBody";
import EditFormTemplate from "../components/DynamicForms/EditFormTemplate/EditFormTemplate";
import SubmittedFormUpdate from "../components/DynamicForms/SubmittedFormUpdate";
import SubmittedFormUpdateHRM from "../components/DynamicForms/SubmittedFormUpdateHRM";
import SubmittedSingleFormView from "../components/DynamicForms/SubmittedSingleFormView";
import SubmittedSingleFormViewHRM from "../components/DynamicForms/SubmittedSingleFormViewHRM";
import ViewFormTemplate from "../components/DynamicForms/ViewFormTemplate/index";
import InviteTeamMember from "../components/Pages/InviteTeamMember/InviteTeamMember";
import AHCatalogServices from "../pages/AlliedHealth/CatalogServices/index";
import AHExternalParticipantProfile from "../pages/AlliedHealth/ExternalParticipantProfile/ExternalParticipantProfile";
import AHExternalServiceProvider from "../pages/AlliedHealth/ExternalServiceProvider/index";
import AHFundingBudget from "../pages/AlliedHealth/Funding/FundingBudget/index";
import AHNdisClaim from "../pages/AlliedHealth/NDISClaim/index";
import AHNdisClaimNew from "../pages/AlliedHealth/NDISClaim/NDISClaimNew/index";
import AHNDISClaimReview from "../pages/AlliedHealth/NDISClaim/NDISClaimReview/index";
import AHCaseNotesHistory from "../pages/AlliedHealth/Participant/CaseNotesHistory/index";
import AHCreateNewInvoices from "../pages/AlliedHealth/Participant/COSInvoices/createNewInvoices/index";
import AHInvoices from "../pages/AlliedHealth/Participant/COSInvoices/index";
import AHInvoicesPreview from "../pages/AlliedHealth/Participant/COSInvoices/InvoicesPreview/index";
import AHDashboard from "../pages/AlliedHealth/Participant/Dashboard/index";
import AHParticipant from "../pages/AlliedHealth/Participant/ParticipantList/index";
import AHParticipantProfile from "../pages/AlliedHealth/Participant/ParticipantProfile/index";
import AHReporting from "../pages/AlliedHealth/Participant/Reporting/index";
import AHCategorySettingPage from "../pages/AlliedHealth/Participant/settings/CategoryPage/index";
import AHContactSettingPage from "../pages/AlliedHealth/Participant/settings/ContactPage/index";
import AHSettings from "../pages/AlliedHealth/Participant/settings/index";
import AHPrioritySettingPage from "../pages/AlliedHealth/Participant/settings/PriorityPage/index";
import Emailcode from "../pages/Authentication/EmailCode/Emailcode";
import Dashboard from "../pages/Dashboard/DashboardNew";
import EmployeeComplaints from "../pages/EmployeePortal/Pages/Complaints/Complaints";
import EmployeeDashboard from "../pages/EmployeePortal/Pages/Dashboard/Dashboard";
import Documents from "../pages/EmployeePortal/Pages/Documents/index";
import EmployeeFeedback from "../pages/EmployeePortal/Pages/Feedback/EmployeeFeedback.container";
import OnBoardingForm from "../pages/EmployeePortal/Pages/OnBoardingForm/OnBoardingFrom";
import Participants from "../pages/EmployeePortal/Pages/Participants/Participants.container";
import EmployeePolicies from "../pages/EmployeePortal/Pages/Policies/Policies";
import EmployeeSettings from "../pages/EmployeePortal/Pages/Settings/Settings";
import WorkerWyzedTraining from "../pages/EmployeePortal/Pages/WyzedTraining/WorkerWyzedTraining";
import AllApplicants from "../pages/HRM/Pages/Applicant/AllApplicants/index";
import ApplicantAssessment from "../pages/HRM/Pages/Applicant/Assessment";
import ApplicantProfile from "../pages/HRM/Pages/Applicant/Profile";
import HRM from "../pages/HRM/Pages/Dashboard/Dashboard";
import TeamManagment from "../pages/HRM/Pages/TeamManagment/index";
import WorkerProfile from "../pages/HRM/Pages/Worker";
import AllForms from "../pages/ServiceProvider/AllForms/index";
import Complaints from "../pages/ServiceProvider/Complaint/index";
import Feedback from "../pages/ServiceProvider/Feedback/index";
import ManagerList from "../pages/ServiceProvider/Manager/index";
import ParticipantProfile from "../pages/ServiceProvider/ParticipantProfile/index";
import ParticipantList from "../pages/ServiceProvider/ParticipantsList/index";
import ServiceProviderSetup from "../pages/ServiceProvider/ServiceProviderSetup/ServiceProviderSetup";
import SpPolicies from "../pages/ServiceProvider/SpPolicies/SpPolicies";
import PolicyCategoriesPage from "../pages/ServiceProvider/SpPolicies/PolicyCategoriesPage";
import PersonalSetting from "../pages/ServiceProvider/SpSetting/index";
import SpSetting from "../pages/ServiceProvider/SpSetting/SpSetting/index";
import FinancialOverview from "../pages/PlatformAdmin/Billing/FinancialOverview";
import StripeManagement from "../pages/PlatformAdmin/Billing/StripeManagement";
import UsageOverview from "../pages/PlatformAdmin/Usage/UsageOverview";
import AiUsageOverview from "../pages/PlatformAdmin/AiUsage/AiUsageOverview";
import ProspectsList from "../pages/PlatformAdmin/Prospects/ProspectsList";
import FeatureOfTheWeekAdmin from "../pages/PlatformAdmin/FeatureOfTheWeek/FeatureOfTheWeekAdmin";
import EventsAdmin from "../pages/PlatformAdmin/Events/EventsAdmin";
import { FEATURE_OF_THE_WEEK_ADMIN_PATH } from "./featureOfTheWeekRoutes";
import PlatformAdminHome from "../pages/PlatformAdmin/Dashboard/PlatformAdminHome";
import TenantsList from "../pages/PlatformAdmin/Tenants/TenantsList";
import TenantDetail from "../pages/PlatformAdmin/Tenants/TenantDetail";
import UserSearch from "../pages/PlatformAdmin/Users/UserSearch";
import StaffUsersList from "../pages/PlatformAdmin/Staff/StaffUsersList";
import PlatformRolesSettings from "../pages/PlatformAdmin/Roles/PlatformRolesSettings";
import PlatformAuditLog from "../pages/PlatformAdmin/Audit/PlatformAuditLog";
import GhostSessionsList from "../pages/PlatformAdmin/Ghost/GhostSessionsList";
import CatalogServices from "../pages/SupportCoordination/CatalogServices/index";
import ExternalParticipantProfile from "../pages/SupportCoordination/ExternalParticipantProfile/ExternalParticipantProfile";
import ExternalServiceProvider from "../pages/SupportCoordination/ExternalServiceProvider/index";
import FundingBudget from "../pages/SupportCoordination/Funding/FundingBudget/index";
import NdisClaim from "../pages/SupportCoordination/NDISClaim/index";
import NdisClaimNew from "../pages/SupportCoordination/NDISClaim/NDISClaimNew/index";
import NDISClaimReview from "../pages/SupportCoordination/NDISClaim/NDISClaimReview/index";
import CaseNotesHistory from "../pages/SupportCoordination/Participant/CaseNotesHistory/index";
import CreateNewInvoices from "../pages/SupportCoordination/Participant/COSInvoices/createNewInvoices/index";
import CosInvoices from "../pages/SupportCoordination/Participant/COSInvoices/index";
import CosInvoicesPreview from "../pages/SupportCoordination/Participant/COSInvoices/InvoicesPreview/index";
import CosDashboard from "../pages/SupportCoordination/Participant/Dashboard/index";
import CosParticipant from "../pages/SupportCoordination/Participant/ParticipantList/index";
import COSParticipantProfile from "../pages/SupportCoordination/Participant/ParticipantProfile/index";
import Reporting from "../pages/SupportCoordination/Participant/Reporting/index";
import CategorySettingPage from "../pages/SupportCoordination/Participant/settings/CategoryPage/index";
import ContactSettingPage from "../pages/SupportCoordination/Participant/settings/ContactPage/index";
import COSSettings from "../pages/SupportCoordination/Participant/settings/index";
import PrioritySettingPage from "../pages/SupportCoordination/Participant/settings/PriorityPage/index";
import TeamMemberSetup from "../pages/TeamMemberSetup/TeamMemberSetup";

import IncidentDashboard from "pages/IncidentManagement/IncidentDashboard";
import CreateIncident from "pages/IncidentManagement/CreateIncident";
import EditIncident from "pages/IncidentManagement/EditIncident";
import ViewIncident from "pages/IncidentManagement/ViewIncident";
import COSReports from "pages/Reporting/COSReports/COSReports";
import NDISClaimsReportsContainer from "pages/Reporting/NDISClaimsReports/NDISClaimsReportsContainer";
import ProgressReports from "pages/Reporting/ProgressReports/ProgressReports";
import TimesheetReportsContainer from "pages/Reporting/TimesheetReports/TimesheetReports.container";
import XeroTimesheetExportReports from "pages/Reporting/XeroTimesheetExportReports/XeroTimesheetExportReports";
import WorkerExpiringDocReportsContainer from "pages/Reporting/WorkerExpiringDocumentsRedports/WorkerExpiringDocReports.container";
import LeaveRequest from "pages/Rostering/LeaveRequest/LeaveRequest";
import UpdatedTimeSheet from "pages/Rostering/UpdatedTimeSheet/UpdatedTimeSheet.container";
import Branding from "pages/ServiceProvider/SpSetting/Branding";
import IncidentReporting from "pages/ServiceProvider/SpSetting/IncidentReportingSetting/IncidentReportingSetting.container";
import RosteringSetting from "pages/ServiceProvider/SpSetting/RosteringSetting/index";
import SilAccommodation from "pages/SilHomes/SilAccommodation";
import SilForms from "pages/SilHomes/SilForms";
import SilHomeProfile from "pages/SilHomes/SilHomeProfile";
import TimesheetList from "../pages/Rostering/Invoicing/CodeAllocation/TimesheetList";
import FundingSettings from "../pages/ServiceProvider/SpSetting/FundingSettings/FundingSettings";
import ServiceAgreementSetting from "../pages/ServiceProvider/SpSetting/ServiceAgreementSetting";
import CustomLineItems from "pages/ServiceProvider/SpSetting/CustomLineItems";
import AiCreditsUsage from "../pages/ServiceProvider/SpSetting/AiCreditsUsage/AiCreditsUsage";
import AiSettings from "../pages/ServiceProvider/SpSetting/AiSettings/AiSettings";
import Vertex360CopilotPage from "../pages/Vertex360Copilot/Vertex360CopilotPage";
import CareWatchPage from "../pages/CareWatch/CareWatch.container";
import Integrations from "../pages/ServiceProvider/SpSetting/Integrations";
import { isAiFeaturesEnabled } from "./aiFeatureFlags";
import AuditLogPage from "../pages/AuditLog/AuditLogPage";
import UserSessionsPage from "../pages/UserSessions/UserSessionsPage";
import SessionTimeline from "../pages/UserSessions/SessionTimeline";

const cosRoutes = [
  //support coordination
  {
    path: "/cos/participant-funding/:uuid/:ptUUID",
    element: <FundingBudget />,
    permissionName: PERMISSION_KEYS.PARTICIPANT,
    permissionChild:
      BLK_PORTAL_PREMISSION_KEYS_CHILDREN.PARTICIPANT.FUNDING.SHOW,
  },
  {
    path: "/cos/dashboard",
    element: <CosDashboard />,
    permissionName: PERMISSION_KEYS.COS,
  },
  {
    path: "/cos/catalog-services",
    element: <CatalogServices />,
    permissionName: PERMISSION_KEYS.COS,
  },
  {
    path: "/cos/external-service-provider",
    element: <ExternalServiceProvider />,
    permissionName: PERMISSION_KEYS.COS,
  },
  
  {
    path: "/cos/external-participant-profile",
    element: <ExternalParticipantProfile />,
    permissionName: PERMISSION_KEYS.COS,
  },
  {
    path: "/cos/participant-list",
    element: <CosParticipant />,
    permissionName: PERMISSION_KEYS.COS,
  },
  {
    path: "/cos/participant-profile/:uuid",
    element: <COSParticipantProfile />,
    permissionName: PERMISSION_KEYS.COS,
  },
  {
    path: "/cos/casenotes-history",
    element: <CaseNotesHistory />,
    permissionName: PERMISSION_KEYS.COS,
  },
  //COS Reporting
  {
    path: "/cos/reporting",
    element: <Reporting />,
    permissionName: PERMISSION_KEYS.COS,
    permissionChild: BLK_PORTAL_PREMISSION_KEYS_CHILDREN.COS.REPORTING.SHOW,
  },

  //COS NDIS Claim
  {
    path: "/cos/ndis-claims",
    element: <NdisClaim />,
    permissionName: PERMISSION_KEYS.COS,
    permissionChild: BLK_PORTAL_PREMISSION_KEYS_CHILDREN.COS.NDIS_CLAIM.SHOW,
  },
  {
    path: "/cos/ndis-claims-new",
    element: <NdisClaimNew />,
    permissionName: PERMISSION_KEYS.COS,
    permissionChild: BLK_PORTAL_PREMISSION_KEYS_CHILDREN.COS.NDIS_CLAIM.SHOW,
  },
  {
    path: "/cos/ndis-claims-review/:uuid",
    element: <NDISClaimReview />,
    permissionName: PERMISSION_KEYS.COS,
    permissionChild: BLK_PORTAL_PREMISSION_KEYS_CHILDREN.COS.NDIS_CLAIM.SHOW,
  },
  // COS Invoices
  {
    path: "/cos/invoice",
    element: <CosInvoices />,
    permissionName: PERMISSION_KEYS.COS,
    permissionChild: BLK_PORTAL_PREMISSION_KEYS_CHILDREN.COS.INVOICES.SHOW,
  },
  {
    path: "/cos/invoice-new",
    element: <CreateNewInvoices />,
    permissionName: PERMISSION_KEYS.COS,
    permissionChild: BLK_PORTAL_PREMISSION_KEYS_CHILDREN.COS.INVOICES.SHOW,
  },
  {
    path: "/cos/invoice-preview/:uuid",
    element: <CosInvoicesPreview />,
    permissionName: PERMISSION_KEYS.COS,
    permissionChild: BLK_PORTAL_PREMISSION_KEYS_CHILDREN.COS.INVOICES.SHOW,
  },
  //COS Settings
  {
    path: "/cos/settings",
    element: <COSSettings />,
    permissionName: PERMISSION_KEYS.COS,
    permissionChild: BLK_PORTAL_PREMISSION_KEYS_CHILDREN.COS.SETTING.SHOW,
  },
  {
    path: "/cos/settings/category-setting",
    element: <CategorySettingPage />,
    permissionName: PERMISSION_KEYS.COS,
    permissionChild: BLK_PORTAL_PREMISSION_KEYS_CHILDREN.COS.SETTING.SHOW,
  },
  {
    path: "/cos/settings/priority-setting",
    element: <PrioritySettingPage />,
    permissionName: PERMISSION_KEYS.COS,
    permissionChild: BLK_PORTAL_PREMISSION_KEYS_CHILDREN.COS.SETTING.SHOW,
  },
  {
    path: "/cos/settings/contact-setting",
    element: <ContactSettingPage />,
    permissionName: PERMISSION_KEYS.COS,
    permissionChild: BLK_PORTAL_PREMISSION_KEYS_CHILDREN.COS.SETTING.SHOW,
  },
];

const ahRoutes = [
  //Allied Health
  {
    path: "/ah/participant-funding/:uuid/:ptUUID",
    element: <AHFundingBudget />,
    permissionName: PERMISSION_KEYS.PARTICIPANT,
    permissionChild:
      BLK_PORTAL_PREMISSION_KEYS_CHILDREN.PARTICIPANT.ALLIED_HEALTH.SHOW,
  },
  {
    path: "/ah/dashboard",
    element: <AHDashboard />,
    permissionName: PERMISSION_KEYS.ALLIED_HEALTH,
  },
  {
    path: "/ah/catalog-services",
    element: <AHCatalogServices />,
    permissionName: PERMISSION_KEYS.ALLIED_HEALTH,
  },
  {
    path: "/ah/external-service-provider",
    element: <AHExternalServiceProvider />,
    permissionName: PERMISSION_KEYS.ALLIED_HEALTH,
  },
  {
    path: "/ah/external-participant-profile",
    element: <AHExternalParticipantProfile />,
    permissionName: PERMISSION_KEYS.ALLIED_HEALTH,
  },
  {
    path: "/ah/participant-list",
    element: <AHParticipant />,
    permissionName: PERMISSION_KEYS.ALLIED_HEALTH,
  },
  {
    path: "/ah/participant-profile/:uuid",
    element: <AHParticipantProfile />,
    permissionName: PERMISSION_KEYS.ALLIED_HEALTH,
  },
  {
    path: "/ah/casenotes-history",
    element: <AHCaseNotesHistory />,
    permissionName: PERMISSION_KEYS.ALLIED_HEALTH,
  },
  //Allied Health Reporting
  {
    path: "/ah/reporting",
    element: <AHReporting />,
    permissionName: PERMISSION_KEYS.ALLIED_HEALTH,
    permissionChild:
      BLK_PORTAL_PREMISSION_KEYS_CHILDREN.ALLIED_HEALTH.REPORTING.SHOW,
  },

  //Allied Health NDIS Claim
  {
    path: "/ah/ndis-claims",
    element: <AHNdisClaim />,
    permissionName: PERMISSION_KEYS.ALLIED_HEALTH,
    permissionChild:
      BLK_PORTAL_PREMISSION_KEYS_CHILDREN.ALLIED_HEALTH.NDIS_CLAIM.SHOW,
  },
  {
    path: "/ah/ndis-claims-new",
    element: <AHNdisClaimNew />,
    permissionName: PERMISSION_KEYS.ALLIED_HEALTH,
    permissionChild:
      BLK_PORTAL_PREMISSION_KEYS_CHILDREN.ALLIED_HEALTH.NDIS_CLAIM.SHOW,
  },
  {
    path: "/ah/ndis-claims-review/:uuid",
    element: <AHNDISClaimReview />,
    permissionName: PERMISSION_KEYS.ALLIED_HEALTH,
    permissionChild:
      BLK_PORTAL_PREMISSION_KEYS_CHILDREN.ALLIED_HEALTH.NDIS_CLAIM.SHOW,
  },
  // Allied Health Invoices
  {
    path: "/ah/invoice",
    element: <AHInvoices />,
    permissionName: PERMISSION_KEYS.ALLIED_HEALTH,
    permissionChild:
      BLK_PORTAL_PREMISSION_KEYS_CHILDREN.ALLIED_HEALTH.INVOICES.SHOW,
  },
  {
    path: "/ah/invoice-new",
    element: <AHCreateNewInvoices />,
    permissionName: PERMISSION_KEYS.ALLIED_HEALTH,
    permissionChild:
      BLK_PORTAL_PREMISSION_KEYS_CHILDREN.ALLIED_HEALTH.INVOICES.SHOW,
  },
  {
    path: "/ah/invoice-preview/:uuid",
    element: <AHInvoicesPreview />,
    permissionName: PERMISSION_KEYS.ALLIED_HEALTH,
    permissionChild:
      BLK_PORTAL_PREMISSION_KEYS_CHILDREN.ALLIED_HEALTH.INVOICES.SHOW,
  },
  //Allied Health Settings
  {
    path: "/ah/settings",
    element: <AHSettings />,
    permissionName: PERMISSION_KEYS.ALLIED_HEALTH,
    permissionChild:
      BLK_PORTAL_PREMISSION_KEYS_CHILDREN.ALLIED_HEALTH.SETTING.SHOW,
  },
  {
    path: "/ah/settings/category-setting",
    element: <AHCategorySettingPage />,
    permissionName: PERMISSION_KEYS.ALLIED_HEALTH,
    permissionChild:
      BLK_PORTAL_PREMISSION_KEYS_CHILDREN.ALLIED_HEALTH.SETTING.SHOW,
  },
  {
    path: "/ah/settings/priority-setting",
    element: <AHPrioritySettingPage />,
    permissionName: PERMISSION_KEYS.ALLIED_HEALTH,
    permissionChild:
      BLK_PORTAL_PREMISSION_KEYS_CHILDREN.ALLIED_HEALTH.SETTING.SHOW,
  },
  {
    path: "/ah/settings/contact-setting",
    element: <AHContactSettingPage />,
    permissionName: PERMISSION_KEYS.ALLIED_HEALTH,
    permissionChild:
      BLK_PORTAL_PREMISSION_KEYS_CHILDREN.ALLIED_HEALTH.SETTING.SHOW,
  },
];

const silHomesRoutes = [
  {
    path: "/sil-accommodation",
    element: <SilAccommodation />,
    permissionName: PERMISSION_KEYS.SIL,
  },
  {
    path: "/sil-accommodation/:uuid",
    element: <SilHomeProfile />,
    permissionName: PERMISSION_KEYS.SIL,
    // permissionChild: PERMISSION_KEYS_CHILDREN.PARTICIPANT.DETAIL,
  },
  {
    path: "/sil-accommodation/:parentSlug/:slug/view",
    element: <SubmittedSingleFormView routeRole="sil" />,
    permissionName: PERMISSION_KEYS.SIL,
    // permissionChild: PERMISSION_KEYS_CHILDREN.PARTICIPANT.DETAIL,
  },
  {
    path: "/sil-accommodation/:parentSlug/:formId/update",
    element: <SubmittedFormUpdate routeRole="sil" />,
    permissionName: PERMISSION_KEYS.SIL,
    // permissionChild: PERMISSION_KEYS_CHILDREN.PARTICIPANT.DETAIL,
  },
  {
    path: "/forms-accommodation",
    element: <SilForms role="sil" />,
    permissionName: PERMISSION_KEYS.SIL,
    // permissionChild: PERMISSION_KEYS_CHILDREN.HRM_FORM.SHOW,
  },
  {
    path: "/sil/create-new-report",
    element: <CreateFormTemplate role="sil" title="Create New Form" />,
    permissionName: PERMISSION_KEYS.SIL,
    // permissionChild: PERMISSION_KEYS_CHILDREN.HRM_FORM.CREATE,
  },

  //Forms

  // UPDATE EXISTING ONE
  {
    path: "/view-template/sil/:ptuuid/:parentSlug/:slug/:isComplete",
    element: <ViewFormTemplate role="sil" />,
    permissionName: PERMISSION_KEYS.SIL,
  },
  // CREATE NEW ONE
  {
    path: "/view-template/sil/:ptuuid/:parentSlug/:slug",
    element: <ViewFormTemplate role="sil" />,
    permissionName: PERMISSION_KEYS.SIL,
  },

  //FORM TEMPALTE FOR READ ONLY
  {
    path: "/view-template/sil/:formTemplateSlug/:templateStatus/read-only",
    element: <ViewFormTemplate role="sil" />,
    permissionName: PERMISSION_KEYS.SIL,
  },
  //Edit Form TemplateSIL FOR DRAFT TEMPLATES UPDATE
  {
    path: "/sil/edit-template/:form_uuid/:form_status",
    element: <CreateFormTemplate role="sil" title="Update Form" />,
    permissionName: PERMISSION_KEYS.SIL,
    // permissionName: PERMISSION_KEYS.CRM_FORM,
    // permissionChild: PERMISSION_KEYS_CHILDREN.CRM_FORM.UPDATE,
  },
  //Edit Form TemplateSIL FOR PUBLISH TEMPLATES UPDATE
  {
    path: "/sil/edit-template/:slug",
    element: <EditFormTemplate role="sil" />,
    permissionName: PERMISSION_KEYS.SIL,
    // permissionName: PERMISSION_KEYS.CRM_FORM,
    // permissionChild: PERMISSION_KEYS_CHILDREN.CRM_FORM.UPDATE,
  },
];

const spAdminAndManagerRoutes = [
  { path: "/", element: <Dashboard /> },
  { path: "/dashboard", element: <Dashboard /> },
  { path: "/release-notes", element: <ReleaseNotes /> },
  {
    path: "/copilot",
    element: <Vertex360CopilotPage />,
    role: [USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager],
  },
  {
    path: "/care-watch",
    element: <CareWatchPage />,
    role: [USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager],
  },
  // My Task Planner
  // { path: "/my-task-planner", element: <MyTaskPlanner /> },

  // Incident Management
  {
    path: "/incident-management",
    element: <IncidentDashboard />,
    permissionName: PERMISSION_KEYS.INCIDENT_MANAGEMENT,
  },
  {
    path: "/incident-management/create",
    element: <CreateIncident />,
    permissionName: PERMISSION_KEYS.INCIDENT_MANAGEMENT,
  },
  {
    path: "/incident-management/edit/:uuid",
    element: <EditIncident />,
    permissionName: PERMISSION_KEYS.INCIDENT_MANAGEMENT,
  },
  {
    path: "/incident-management/view/:uuid",
    element: <ViewIncident />,
    permissionName: PERMISSION_KEYS.INCIDENT_MANAGEMENT,
  },

  //Stripe Payment
  {
    path: "/subscription",
    element: <SubscriptionDetailsDashboard />,
    role: [USER_ROLE.Sp_Admin],
    isWildRoute: true,
  },
  {
    path: "/subscription/plans",
    element: <PricingTable />,
    role: [USER_ROLE.Sp_Admin],
    isWildRoute: true,
  },
  // { path: "/subscription/billing-method", element: <PaymentMethod /> },
  // { path: "/invoices", element: <StripeInvoices /> },

  //Settings
  {
    path: "/settings",
    element: <PersonalSetting />,
    role: [USER_ROLE.Sp_Admin],
  },
  {
    path: "/settings/sp-setting",
    element: <SpSetting />,
    role: [USER_ROLE.Sp_Admin],
  },
  {
    path: "/settings/worker-compliance-setting",
    element: <StaffCompliance />,
    role: [USER_ROLE.Sp_Admin],
  },
  {
    path: "/settings/participant-compliance-setting",
    element: <ParticipantComplianceEdit />,
    role: [USER_ROLE.Sp_Admin],
  },
  {
    path: "/settings/participant-compliance-setting/:profileUuid",
    element: <ParticipantComplianceEdit />,
    role: [USER_ROLE.Sp_Admin],
  },
  {
    path: "/settings/rostering-setting",
    element: <RosteringSetting />,
    role: [USER_ROLE.Sp_Admin],
  },
  {
    path: "/settings/region-setting",
    element: <RegionSetting />,
    role: [USER_ROLE.Sp_Admin],
  },
  {
    path: "/settings/incident-reporting-setting",
    element: <IncidentReporting />,
    role: [USER_ROLE.Sp_Admin],
  },
  {
    path: "/settings/branding",
    element: <Branding />,
    role: [USER_ROLE.Sp_Admin],
  },
  {
    path: "/settings/funding-setting",
    element: <FundingSettings />,
    role: [USER_ROLE.Sp_Admin],
  },
  {
    path: "/settings/service-agreement-setting",
    element: <ServiceAgreementSetting />,
    role: [USER_ROLE.Sp_Admin],
  },
  {
    path: "/settings/service-categories-line-items",
    element: <CustomLineItems />,
    role: [USER_ROLE.Sp_Admin],
  },
  {
    path: "/settings/custom-line-items",
    element: <Navigate to="/settings/service-categories-line-items" replace />,
    role: [USER_ROLE.Sp_Admin],
  },
  {
    path: "/settings/integrations",
    element: <Integrations />,
    role: [USER_ROLE.Sp_Admin],
  },
  ...(isAiFeaturesEnabled
    ? [
        {
          path: "/settings/ai-settings",
          element: <AiSettings />,
          role: [USER_ROLE.Sp_Admin],
        },
        {
          path: "/settings/ai-usage",
          element: <AiCreditsUsage />,
          role: [USER_ROLE.Sp_Admin],
        },
        {
          path: "/settings/ai",
          element: <Navigate to="/settings/ai-usage" replace />,
          role: [USER_ROLE.Sp_Admin],
        },
      ]
    : []),
  {
    path: "/notification-setting",
    element: <NotificationSettings />,
  },
  {
    path: "/roles-permissions-setting",
    element: <RolesAndPermissions />,
  },
  {
    path: "/payroll-setting/:platform/:status",
    element: <PayrollSetting />,
  },
  {
    path: "/payroll-setting",
    element: <PayrollSetting />,
    permissionName: PERMISSION_KEYS.ROSTERING,
    permissionChild: PERMISSION_KEYS_CHILDREN.ROSTERING.TIMESHEET_EXPORT.SHOW,
  },
  {
    path: "/xero-auth/:apiResponse",
    element: <PayrollAuthCallback type={PAYROLL_PLATFORMS.XERO} />,
  },
  {
    path: "/quick-books-auth/:apiResponse",
    element: <PayrollAuthCallback type={PAYROLL_PLATFORMS.QUICKBOOKS} />,
  },

  //HRM
  { path: "/hrm", element: <HRM />, permissionName: PERMISSION_KEYS.HRM },
  {
    path: "/hrm/all-applicants",
    element: <AllApplicants />,
    permissionName: PERMISSION_KEYS.HRM,
    permissionChild: PERMISSION_KEYS_CHILDREN.HRM.APPLICANT.SHOW,
  },
  {
    path: "/hrm/applicant-profile",
    element: <ApplicantProfile />,
    permissionName: PERMISSION_KEYS.HRM,
    permissionChild: PERMISSION_KEYS_CHILDREN.HRM.APPLICANT.SHOW,
  },
  {
    path: "/hrm/applicant-assessment",
    element: <ApplicantAssessment />,
    permissionName: PERMISSION_KEYS.HRM,
    permissionChild: PERMISSION_KEYS_CHILDREN.HRM.APPLICANT.ASSESSMENT,
  },
  {
    path: "/hrm/team-management",
    element: <TeamManagment />,
    permissionName: PERMISSION_KEYS.HRM,
    permissionChild: PERMISSION_KEYS_CHILDREN.HRM.WORKER.SHOW,
  },
  {
    path: "/hrm/all-managers",
    element: <ManagerList />,
    permissionName: PERMISSION_KEYS.HRM,
    permissionChild: PERMISSION_KEYS_CHILDREN.HRM.MANAGER.SHOW,
  },

  //Worker Profile
  {
    path: "/worker-profile/:parentSlug/:slug/view",
    element: <SubmittedSingleFormViewHRM />,
    permissionName: PERMISSION_KEYS.HRM,
    permissionChild: PERMISSION_KEYS_CHILDREN.HRM.WORKER.SHOW,
  },
  {
    path: "/worker-profile/:parentSlug/:formId/update",
    element: <SubmittedFormUpdateHRM />,
    permissionName: PERMISSION_KEYS.HRM,
    permissionChild: PERMISSION_KEYS_CHILDREN.HRM.WORKER.SHOW,
  },
  {
    path: "/worker-profile/:workerId",
    element: <WorkerProfile />,
    permissionName: PERMISSION_KEYS.HRM,
    permissionChild: PERMISSION_KEYS_CHILDREN.HRM.WORKER.SHOW,
  },

  //Form Template Listing (PUBLISH/DRAFT)
  {
    path: "/forms-list",
    element: <AllForms role="crm" />,
    permissionName: PERMISSION_KEYS.CRM_FORM,
    permissionChild: PERMISSION_KEYS_CHILDREN.CRM_FORM.SHOW,
  },
  {
    path: "/forms-list-hrm",
    element: <AllForms role="hrm" />,
    permissionName: PERMISSION_KEYS.HRM_FORM,
    permissionChild: PERMISSION_KEYS_CHILDREN.HRM_FORM.SHOW,
  },

  //Create New Form Template CRM & HRM
  {
    path: "/crm/create-new-report",
    element: <CreateFormTemplate role="crm" title="Create New Form" />,
    permissionName: PERMISSION_KEYS.CRM_FORM,
    permissionChild: PERMISSION_KEYS_CHILDREN.CRM_FORM.CREATE,
  },
  {
    path: "/hrm/create-new-report",
    element: <CreateFormTemplate role="hrm" title="Create New Form" />,
    permissionName: PERMISSION_KEYS.HRM_FORM,
    permissionChild: PERMISSION_KEYS_CHILDREN.HRM_FORM.CREATE,
  },

  //Edit Form Template CRM & HRM FOR DRAFT TEMPLATES UPDATE
  {
    path: "/crm/edit-template/:form_uuid/:form_status",
    element: <CreateFormTemplate role="crm" title="Update Form" />,
    permissionName: PERMISSION_KEYS.CRM_FORM,
    permissionChild: PERMISSION_KEYS_CHILDREN.CRM_FORM.UPDATE,
  },
  {
    path: "/hrm/edit-template/:form_uuid/:form_status",
    element: <CreateFormTemplate role="hrm" title="Update Form" />,
    permissionName: PERMISSION_KEYS.HRM_FORM,
    permissionChild: PERMISSION_KEYS_CHILDREN.HRM_FORM.UPDATE,
  },

  //Edit Form Template CRM & HRM FOR PUBLISH FORM TEMPLATE
  {
    path: "/edit-template/:slug",
    element: <EditFormTemplate role="crm" />,
    permissionName: PERMISSION_KEYS.CRM_FORM,
    permissionChild: PERMISSION_KEYS_CHILDREN.CRM_FORM.UPDATE,
  },
  {
    path: "/edit-template/hrm/:slug",
    element: <EditFormTemplate role="hrm" />,
    permissionName: PERMISSION_KEYS.HRM_FORM,
    permissionChild: PERMISSION_KEYS_CHILDREN.HRM_FORM.UPDATE,
  },

  //Participants
  {
    path: "/participant-list",
    element: <ParticipantList />,
    permissionName: PERMISSION_KEYS.PARTICIPANT,
  },

  //Participant Profile
  {
    path: "/sp-profile/:uuid",
    element: <ParticipantProfile />,
    permissionName: PERMISSION_KEYS.PARTICIPANT,
    permissionChild: PERMISSION_KEYS_CHILDREN.PARTICIPANT.DETAIL,
  },
  {
    path: "/sp-profile/funding/:ptUUID/:uuid",
    element: <FundingBudget />,
    permissionName: PERMISSION_KEYS.PARTICIPANT,
    permissionChild:
      BLK_PORTAL_PREMISSION_KEYS_CHILDREN.PARTICIPANT.FUNDING.SHOW,
  },
  {
    path: "/sp-profile/:parentSlug/:slug/view",
    element: <SubmittedSingleFormView />,
    permissionName: PERMISSION_KEYS.PARTICIPANT,
    permissionChild: PERMISSION_KEYS_CHILDREN.PARTICIPANT.DETAIL,
  },
  {
    path: "/sp-profile/:parentSlug/:formId/update",
    element: <SubmittedFormUpdate />,
    permissionName: PERMISSION_KEYS.PARTICIPANT,
    permissionChild: PERMISSION_KEYS_CHILDREN.PARTICIPANT.DETAIL,
  },

  //Human Body Modal
  { path: "/humanbody", element: <HumanBody /> },

  //Forms For Participants
  {
    path: "/view-template/:ptuuid/:parentSlug/:slug/:isComplete",
    element: <ViewFormTemplate role="crm" />,
  },
  {
    path: "/view-template/:ptuuid/:parentSlug/:slug",
    element: <ViewFormTemplate role="crm" />,
  },
  {
    path: "/view-template/hrm/:ptuuid/:parentSlug/:slug/:isComplete",
    element: <ViewFormTemplate role="hrm" />,
  },
  {
    path: "/view-template/hrm/:ptuuid/:parentSlug/:slug",
    element: <ViewFormTemplate role="hrm" />,
  },

  //Teams
  { path: "/invite-member", element: <InviteTeamMember /> },

  //View template Only in Read-only view for both crm & hrm
  {
    path: "/view-template/crm/:formTemplateSlug/:templateStatus/read-only",
    element: <ViewFormTemplate role="crm" />,
  },
  {
    path: "/view-template/hrm/:formTemplateSlug/:templateStatus/read-only",
    element: <ViewFormTemplate role="hrm" />,
  },

  //complaints, feedback & Policy
  {
    path: "/complaints",
    element: <Complaints />,
    permissionName: PERMISSION_KEYS.COMPLAINT,
  },
  {
    path: "/feedbacks",
    element: <Feedback />,
    permissionName: PERMISSION_KEYS.FEEDBACK,
  },
  {
    path: "/policies",
    element: <SpPolicies />,
    permissionName: PERMISSION_KEYS.POLICy,
  },
  {
    path: "/policies/categories",
    element: <PolicyCategoriesPage />,
    permissionName: PERMISSION_KEYS.POLICy,
    permissionChild: PERMISSION_KEYS_CHILDREN.POLICY.CREATE,
  },
  {
    path: "/ask-a-question",
    element: <AskQuestion />,
    permissionName: PERMISSION_KEYS.ASK_QUESTION,
    permissionChild: PERMISSION_KEYS_CHILDREN.ASK_QUESTION.SHOW,
  },

  //Support Coordination
  ...cosRoutes,

  //Allied Health
  ...ahRoutes,

  //SilHomes Routes
  ...silHomesRoutes,

  // Rostering Routes
  {
    path: "/rostering/dashboard",
    element: <RosteringDashboard />,
    permissionName: PERMISSION_KEYS.ROSTERING,
  },
  {
    path: "/rostering/schedule",
    element: <Schedule />,
    permissionName: PERMISSION_KEYS.ROSTERING,
    permissionChild: PERMISSION_KEYS_CHILDREN.ROSTERING.SCHEDULE.SHOW,
  },
  //{
  //path: "/rostering/old-timesheet",
  //element: <TimeSheet />,
  //permissionName: PERMISSION_KEYS.ROSTERING,
  //permissionChild: PERMISSION_KEYS_CHILDREN.ROSTERING.TIMESHEET.SHOW,
  //},
  {
    path: "/rostering/timesheet",
    element: <UpdatedTimeSheet />,
    permissionName: PERMISSION_KEYS.ROSTERING,
    permissionChild: PERMISSION_KEYS_CHILDREN.ROSTERING.TIMESHEET.SHOW,
  },
  {
    path: "/rostering/timesheetExport",
    element: <ExportTimeSheet />,
    permissionName: PERMISSION_KEYS.ROSTERING,
    permissionChild: PERMISSION_KEYS_CHILDREN.ROSTERING.TIMESHEET_EXPORT.SHOW,
  },
  {
    path: "/rostering/leaverequests",
    element: <LeaveRequest />,
    permissionName: PERMISSION_KEYS.ROSTERING,
    permissionAnyChildren: ROSTERING_LEAVE_ACCESS_CHILDREN,
  },
  {
    path: "/rostering/invoicing/dashboard",
    element: <RosterInvoicingDashboard />,
    permissionName: PERMISSION_KEYS.ROSTER_INVOICE,
    permissionAnyChildren: [
      PERMISSION_KEYS_CHILDREN.ROSTER_INVOICE.ALLOCATION,
      PERMISSION_KEYS_CHILDREN.ROSTER_INVOICE.CREATE,
    ],
  },
  {
    path: "/rostering/invoicing",
    element: <RosterInvoicing />,
    permissionName: PERMISSION_KEYS.ROSTER_INVOICE,
    permissionChild: PERMISSION_KEYS_CHILDREN.ROSTER_INVOICE.CREATE,
  },
  {
    path: "/rostering/create-roster-invoice",
    element: <CreateRosterInvoicing />,
    permissionName: PERMISSION_KEYS.ROSTER_INVOICE,
    permissionChild: PERMISSION_KEYS_CHILDREN.ROSTER_INVOICE.CREATE,
  },
  {
    path: "/rostering/roster-invoice-preview/:uuid",
    element: <RosterInvoicePreview />,
    permissionName: PERMISSION_KEYS.ROSTER_INVOICE,
    permissionChild: PERMISSION_KEYS_CHILDREN.ROSTER_INVOICE.CREATE,
  },
  {
    path: "/rostering/invoicing/allocation",
    element: <TimesheetList />,
    permissionName: PERMISSION_KEYS.ROSTER_INVOICE,
    permissionChild: PERMISSION_KEYS_CHILDREN.ROSTER_INVOICE.ALLOCATION,
  },
  //Reporting routes
  {
    path: "/reporting",
    element: <ReportingModule />,
    // permissionName: PERMISSION_KEYS.ROSTER_INVOICE,
  },
  {
    path: "/reporting/export-history",
    element: <ExportHistory />,
  },
  {
    path: "/reporting/roc-reports",
    element: <RocReports />,
  },
  {
    path: "/reporting/timesheet-reports",
    element: <TimesheetReportsContainer />,
  },
  {
    path: "/reporting/xero-timesheet-export-reports",
    element: <XeroTimesheetExportReports />,
  },
  {
    path: "/reporting/cos-reports",
    element: <COSReportsContainer />,
  },
  {
    path: "/reporting/incident-reports",
    element: <IncidentReports />,
  },
  {
    path: "/reporting/incident-management-reports",
    element: <IncidentManagementReports />,
  },
  {
    path: "/reporting/feedback-reports",
    element: <FeedbackReports />,
  },
  {
    path: "/reporting/complaints-reports",
    element: <ComplaintsReports />,
  },
  {
    path: "/reporting/participant-listing-reports",
    element: <ParticipantListReports />,
  },
  {
    path: "/reporting/participant-expiring-documents-reports",
    element: <ParticipantExpiringDocReportsContainer />,
  },
  {
    path: "/reporting/worker-list-reports",
    element: <WorkerListReports />,
  },
  {
    path: "/reporting/worker-expiring-documents-reports",
    element: <WorkerExpiringDocReportsContainer />,
  },
  {
    path: "/reporting/kyp-reports",
    element: <KYPReportsContainer />,
  },
  {
    path: "/reporting/invoicing-reports",
    element: <InvoicingReports />,
  },
  {
    path: "/reporting/cos-reports",
    element: <COSReports />,
  },
  {
    path: "/reporting/case-notes-reports",
    element: <CaseNoteReportsContainer />,
  },
  {
    path: "/reporting/bsp-reports",
    element: <BSPReports />,
  },
  {
    path: "/reporting/roc-weekly-reports",
    element: <ROCWeeklyReport />,
  },
  {
    path: "/reporting/risk-assessment-reports",
    element: <RiskAssessmentReports />,
  },
  {
    path: "/reporting/progress-reports",
    element: <ProgressReports />,
  },
  {
    path: "/reporting/funding-reports",
    element: <FundingReportsContainer />,
  },
  {
    path: "/reporting/summary-invoicing-reports",
    element: <SummaryInvoicingReport />,
  },
  {
    path: "/reporting/detailed-invoicing-reports",
    element: <DetailedInvoicingReport />,
  },
  {
    path: "/reporting/ndis-claims-reports",
    element: <NDISClaimsReportsContainer />,
  },

  // Audit Log (SP Admin by default; SP admin can grant audit_log.view via Roles & Permissions)
  {
    path: "/audit-log",
    element: <AuditLogPage />,
    role: [USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager],
    permissionName: "audit_log",
  },

  // User Sessions / Journey Tracking (SP Admin by default; SP admin can grant user_sessions.view via Roles & Permissions)
  {
    path: "/user-sessions",
    element: <UserSessionsPage />,
    role: [USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager],
    permissionName: "user_sessions",
  },
  {
    path: "/user-sessions/:sessionId",
    element: <SessionTimeline />,
    role: [USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager],
    permissionName: "user_sessions",
  },
];

export const DynamicRoutes = {
  public: [
    { path: "/", element: <SignIn /> },
    { path: "/signup", element: <SignUp /> },
    //Invite Service Provider
    { path: "/sp-invitation/:id", element: <ServiceProviderSetup /> },
    { path: "/member-invitation", element: <TeamMemberSetup /> },
    { path: "/forget-password", element: <ForgetPassword /> },
    { path: "/family-set-password", element: <FamilySetPassword /> },
    // { path: "/emailcomfirm", element: <EmailConfirm /> },
    { path: "/reset-password", element: <SetPassword /> },
    { path: "/confirmpassword", element: <ConfirmedPassword /> },
    { path: "/:slug", element: <SignIn /> },
    //Email confirmation Code
    { path: "/email-verification-code/:encodedEmail", element: <Emailcode /> },

    // { path: "/reports-form", element: <ReportForm /> },

    //Public Form Submission
    {
      path: "/view-template/:ptuuid/:parentSlug/:slug/:publicId",
      element: <ViewFormTemplate role="crm" />,
    },

    {
      path: "/view-template/hrm/:ptuuid/:parentSlug/:slug/:publicId",
      element: <ViewFormTemplate role="hrm" />,
    },

    {
      path: "/view-template/sil/:ptuuid/:parentSlug/:slug/:publicId",
      element: <ViewFormTemplate role="sil" />,
    },

    { path: "/:slug", element: <SignIn /> },

    { path: "*", element: <Navigate to="/" /> },
  ],

  super_admin: [
    { path: "/", element: <PlatformAdminHome /> },
    { path: "/dashboard", element: <PlatformAdminHome /> },
    { path: "/release-notes", element: <ReleaseNotes /> },
    //Create New Form Template CRM & HRM
    {
      path: "/crm/create-new-report",
      element: <CreateFormTemplate role="crm" title="Create New Form" />,
    },
    {
      path: "/hrm/create-new-report",
      element: <CreateFormTemplate role="hrm" title="Create New Form" />,
    },

    //Edit Form Template CRM & HRM FOR DRAFT FORM TEMPLATE
    {
      path: "/crm/edit-template/:form_uuid/:form_status",
      element: <CreateFormTemplate role="crm" title="Update Form" />,
    },
    {
      path: "/hrm/edit-template/:form_uuid/:form_status",
      element: <CreateFormTemplate role="hrm" title="Update Form" />,
    },

    //CRM View Form Template
    {
      path: "/crm/view-template/:ptuuid/:parentSlug/:slug/:isComplete",
      element: <ViewFormTemplate role="crm" />,
    },
    {
      path: "/crm/view-template/:parentSlug/:slug",
      element: <ViewFormTemplate role="crm" />,
    },

    //HRM View Form Template
    {
      path: "/hrm/view-template/:ptuuid/:parentSlug/:slug/:isComplete",
      element: <ViewFormTemplate role="hrm" />,
    },
    {
      path: "/hrm/view-template/:parentSlug/:slug",
      element: <ViewFormTemplate role="hrm" />,
    },

    //CRM & HRM Form listing
    { path: "/forms-list", element: <AllForms role="crm" /> },
    { path: "/forms-list-hrm", element: <AllForms role="hrm" /> },

    // Submitted Form TEMPLATE Edit CRM & HRM (PUBLISH FORM TEMPLATE)
    { path: "/edit-template/:slug", element: <EditFormTemplate role="crm" /> },
    {
      path: "/edit-template/hrm/:slug",
      element: <EditFormTemplate role="hrm" />,
    },

    { path: "/tenants", element: <TenantsList /> },
    { path: "/tenants/:id", element: <TenantDetail /> },
    { path: "/users", element: <UserSearch /> },
    { path: "/staff-users", element: <StaffUsersList /> },
    { path: "/platform-roles", element: <PlatformRolesSettings /> },
    { path: "/audit-log", element: <PlatformAuditLog /> },
    { path: "/ghost-sessions", element: <GhostSessionsList /> },
    { path: "/billing", element: <FinancialOverview /> },
    { path: "/stripe", element: <StripeManagement /> },
    { path: "/plans", element: <StripeManagement initialTab="plans" /> },
    { path: "/usage", element: <UsageOverview /> },
    { path: "/ai-usage", element: <AiUsageOverview /> },
    { path: "/prospects", element: <ProspectsList /> },
    { path: FEATURE_OF_THE_WEEK_ADMIN_PATH, element: <FeatureOfTheWeekAdmin /> },
    { path: "/platform/events", element: <EventsAdmin /> },
    { path: "/sp-list", element: <Navigate to="/tenants" replace /> },
  ],

  sp_admin: [...spAdminAndManagerRoutes],

  sp_manager: [...spAdminAndManagerRoutes],

  sp_standard_user: [
    //On Boarding Form
    { path: "/", element: <OnBoardingForm /> },
    { path: "/release-notes", element: <ReleaseNotes /> },

    //Dashboard
    {
      path: "/dashboard",
      element: <EmployeeDashboard />,
      // permissionName: PERMISSION_KEYS.DASHBOARD,
    },

    // Incident Management for Workers
    {
      path: "/incident-management",
      element: <IncidentDashboard />,
      permissionName: PERMISSION_KEYS.INCIDENT_MANAGEMENT,
    },
    {
      path: "/incident-management/create",
      element: <CreateIncident />,
      permissionName: PERMISSION_KEYS.INCIDENT_MANAGEMENT,
    },
    {
      path: "/incident-management/edit/:uuid",
      element: <EditIncident />,
      permissionName: PERMISSION_KEYS.INCIDENT_MANAGEMENT,
    },
    {
      path: "/incident-management/view/:uuid",
      element: <ViewIncident />,
      permissionName: PERMISSION_KEYS.INCIDENT_MANAGEMENT,
    },

    //Document
    {
      path: "/documents",
      element: <Documents />,
      permissionName: PERMISSION_KEYS.DOCUMENT,
    },

    // Wyzed training (sidebar + dashboard when worker has wyzed.view_training)
    {
      path: "/wyzed-training",
      element: <WorkerWyzedTraining />,
      permissionName: PERMISSION_KEYS.WYZED,
      permissionChild: BLK_PORTAL_PREMISSION_KEYS_CHILDREN.WYZED.VIEW_TRAINING,
    },

    //participant List
    {
      path: "/participants",
      element: <Participants />,
      permissionName: PERMISSION_KEYS.PARTICIPANT,
    },

    //Participant Profile
    {
      path: "/participant-profile/:uuid",
      element: <ParticipantProfile />,
      permissionName: PERMISSION_KEYS.PARTICIPANT,
      permissionChild: BLK_PORTAL_PREMISSION_KEYS_CHILDREN.PARTICIPANT.DETAIL,
    },
    {
      path: "/sp-profile/funding/:ptUUID/:uuid",
      element: <FundingBudget />,
      permissionName: PERMISSION_KEYS.PARTICIPANT,
      permissionChild:
        BLK_PORTAL_PREMISSION_KEYS_CHILDREN.PARTICIPANT.FUNDING.SHOW,
    },
    // Participant Forms Submitted From worker protal
    {
      path: "/participant-profile/:parentSlug/:slug/view",
      element: <SubmittedSingleFormView routeRole="crm" />,
    },
    {
      path: "/participant-profile/:parentSlug/:formId/update",
      element: <SubmittedFormUpdate />,
    },

    //CRM View form of Participant's
    {
      path: "/view-template/:ptuuid/:parentSlug/:slug/:isComplete",
      element: <ViewFormTemplate role="crm" />,
    },
    {
      path: "/view-template/:ptuuid/:parentSlug/:slug",
      element: <ViewFormTemplate role="crm" />,
    },

    // Worker HRM View & submit new form and update existing inComplete form
    {
      path: "/view-template/hrm/:ptuuid/:parentSlug/:slug/:isComplete",
      element: <ViewFormTemplate role="worker" />,
      permissionName: PERMISSION_KEYS.SUBMITTED,
      permissionChild:
        BLK_PORTAL_PREMISSION_KEYS_CHILDREN.SUBMITTED.FORM.CREATE,
    },
    {
      path: "/view-template/hrm/:ptuuid/:parentSlug/:slug",
      element: <ViewFormTemplate role="worker" />,
      permissionName: PERMISSION_KEYS.SUBMITTED,
      permissionChild:
        BLK_PORTAL_PREMISSION_KEYS_CHILDREN.SUBMITTED.FORM.CREATE,
    },

    //HRM Submitted Form & All Forms Listing and Update complete form View
    {
      path: "/submitted-forms",
      element: <SubmittedForms />,
      permissionName: PERMISSION_KEYS.SUBMITTED,
      permissionChild: BLK_PORTAL_PREMISSION_KEYS_CHILDREN.SUBMITTED.SHOW,
    },
    {
      path: "/submitted-form/:parentSlug/:slug/view",
      element: <SubmittedSingleFormView routeRole="worker" />,
      permissionName: PERMISSION_KEYS.SUBMITTED,
      permissionChild: BLK_PORTAL_PREMISSION_KEYS_CHILDREN.SUBMITTED.FORM.VIEW,
    },
    {
      path: "/submitted-form/:parentSlug/:formId/update",
      element: <SubmittedFormUpdate routeRole="worker" />,
      permissionName: PERMISSION_KEYS.SUBMITTED,
      permissionChild:
        BLK_PORTAL_PREMISSION_KEYS_CHILDREN.SUBMITTED.FORM.CREATE,
    },

    //Complaints & Feedback & Policy
    {
      path: "/complaint",
      element: <EmployeeComplaints />,
      permissionName: PERMISSION_KEYS.COMPLAINT,
    },
    {
      path: "/feedback",
      element: <EmployeeFeedback />,
      permissionName: PERMISSION_KEYS.FEEDBACK,
    },
    {
      path: "/ask-a-question",
      element: <AskQuestion />,
      permissionName: PERMISSION_KEYS.ASK_QUESTION,
      permissionChild: PERMISSION_KEYS_CHILDREN.ASK_QUESTION.SHOW,
    },
    {
      path: "/employee-policies",
      element: <EmployeePolicies />,
      permissionName: PERMISSION_KEYS.POLICy,
    },

    //Support coordination
    ...cosRoutes,

    //Allied Health
    ...ahRoutes,

    //Sp Standard User Settings
    { path: "/settings", element: <EmployeeSettings /> },
  ],

  sp_cos: [{ path: "*", element: <ComingSoonPage /> }],
};
